import React from 'react';
import { Input, Typography } from 'antd';
import { FormikProps } from 'formik';

import * as S from '../../styles/PromptEdit.styles';
import { PromptProps } from '../../service/ai.interface';

const { Text } = Typography;

export const PromptForm = ({
    formik,
}: {
    formik: FormikProps<PromptProps>;
}) => {
    return (
        <>
            <S.Field gap={8} vertical>
                <Text>Стандартный ИИ промпт</Text>
                <Input.TextArea
                    value={formik.values.prompt}
                    name='prompt'
                    rows={16}
                    onChange={formik.handleChange}
                />
            </S.Field>
            <S.Field gap={8} vertical>
                <Text>Приветственное сообщение</Text>
                <Input.TextArea
                    value={formik.values.first_message}
                    name='first_message'
                    rows={8}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    status={
                        formik.touched.first_message &&
                        formik.errors.first_message
                            ? 'error'
                            : undefined
                    }
                />
                {formik.touched.first_message &&
                    formik.errors.first_message && (
                        <Text type='danger'>{formik.errors.first_message}</Text>
                    )}
            </S.Field>
        </>
    );
};
